module.exports = __webpack_public_path__ + "static/media/bg-hamburger-menu.6f97bd04.png";